import _styled from "@emotion/styled/base";
import MenuButtonImage from './MenuButton.png';
var MenuButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "egsd30z0"
} : {
  target: "egsd30z0",
  label: "MenuButton"
})(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    backgroundImage = _ref.backgroundImage;
  return {
    width: '48px',
    height: '48px',
    backgroundColor: 'white',
    backgroundImage: "url(".concat(backgroundImage || MenuButtonImage, ")"),
    backgroundSize: 'auto 100%',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    margin: 0,
    borderRadius: '10px',
    outline: 0,
    boxShadow: 'none',
    // border: '1px solid #F486CA',
    borderWidth: 0,
    transition: 'all 0.2s ease-in-out 0s',
    '@media (hover)': {
      '&:hover': {
        backgroundColor: '#F486CA'
      }
    },
    cursor: 'pointer'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
// const MenuInput = styled.input(({ backgroundImage, backgroundColor }) => ({
//   width: '48px',
//   height: '48px',
//   backgroundColor,
//   backgroundImage,
//   backgroundSize: 'auto 100%',
//   backgroundPosition: 'center center',
//   backgroundRepeat: 'no-repeat',
//   margin: 0,
//   borderRadius: '10px',
//   outline: 0,
//   boxShadow: 'none',
//   // border: '1px solid #F486CA',
//   borderWidth: 0,
//   transition: 'all 0.2s ease-in-out 0s',
//   '&:hover': {
//     backgroundColor: '#F486CA'
//   },
//   cursor: 'pointer'
// }))

// const MenuButton = ({ onClick, reset, backgroundImage, ...props }) => {
//   const [ backgroundColor, setBackgroundColor ] = useState('white')

//   const onClickHandler = () => {
//     if (backgroundColor === 'white') {
//       setBackgroundColor('#F486CA')
//     } else {
//       setBackgroundColor('white')
//     }
//     onClick()
//   }

//   useEffect(() => {
//     setBackgroundColor('white')
//   }, [reset])

//   return (
//     <MenuInput onClick={onClickHandler} backgroundImage={`url(${backgroundImage})`} backgroundColor={backgroundColor} {...props} />
//   )
// }

export { MenuButton };
//# sourceMappingURL=MenuButton.js.map